import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../hooks/useLanguage';

function CompanyInformation({ formData, handleChange }) {
  const [isSpanish] = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-full mt-10">
      {/* Title */}
      <div className="mb-4 flex items-end gap-2">
        <h2 className="text-3xl font-bold text-gray-900">
          {isSpanish ? 'Información de la Empresa' : 'Company Information'}
        </h2>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="cursor-pointer hover:opacity-70 transition-opacity"
          aria-label={isSpanish ? 'Expandir/Colapsar' : 'Expand/Collapse'}
        >
          <ChevronDown
            className={`size-6 text-gray-600 transition-transform duration-200 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </button>
      </div>

      {/* Company Information Form */}
      {isExpanded && (
      <div className="bg-white rounded-lg border-container p-6 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          {/* Company Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {isSpanish ? 'Nombre de la Empresa' : 'Company Name'} *
            </label>
              <span className="font-bold text-xl text-gray-900">{formData.companyName || (isSpanish ? 'No especificado' : 'Not specified')}</span>
          </div>

          {/* Email Address */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {isSpanish ? 'Dirección de Correo Electrónico' : 'Email Address'} *
            </label>
              <span className="font-bold text-xl text-gray-900">{formData.emailAddress || (isSpanish ? 'No especificado' : 'Not specified')}</span>
          </div>
        </div>

        {/* Expected Number of DUAs */}
        <div className="mb-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {isSpanish ? 'Número Esperado de DUAs por mes' : 'Expected Number of DUAs per month'} *
          </label>
            <span className="font-bold text-xl text-gray-900">{formData.expectedDUAs || (isSpanish ? 'No especificado' : 'Not specified')}</span>
        </div>
      </div>
      )}
    </div>
  );
}

export default CompanyInformation;

